/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type userTracking_viewer = {
    readonly transactionsCounter?: {
        readonly submittedTransactions?: number | null;
        readonly confirmedTransactions?: number | null;
        readonly guestCheckoutTransactions: number | null;
    } | null;
    readonly " $refType": "userTracking_viewer";
};
export type userTracking_viewer$data = userTracking_viewer;
export type userTracking_viewer$key = {
    readonly " $data"?: userTracking_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"userTracking_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "userTracking_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "checkoutUserId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasCheckoutUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasCheckoutUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "transactionsCounter",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "checkoutUserId"
            }
          ],
          "concreteType": "TransactionsCounter",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": "guestCheckoutTransactions",
              "name": "guest",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "Condition",
              "passingValue": true,
              "condition": "hasUserId",
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": "submittedTransactions",
                  "name": "submitted",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": "confirmedTransactions",
                  "name": "confirmed",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'ccc2594bb1100b6116146ab8a2ff6863';
export default node;
